import { useState, useContext, useEffect } from "react";
import { Container, Group, Image, Button, TextInput } from "@mantine/core";
import ExperienceContext from "./ExperienceContext";
import linkIcon from "../../static/svg/link.svg";
function EmbedLinkControls({ activePanoId, selectedObject, closeControls }) {
	const [link, setLink] = useState(selectedObject.link);
	const { deleteLinkspot, changeLinkspotlink } =
		useContext(ExperienceContext);
	useEffect(() => {
		setLink(selectedObject.link);
	}, [selectedObject]);
	return (
		<Group
			style={{
				height: "96px",
				width: "340px",
				backgroundColor: "#040f1fcc",
				padding: "10px 20px 10px 20px",
				borderRadius: "5px",
			}}
		>
			<Container
				px={0}
				mx={0}
				style={{
					backgroundColor: "#00000099",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					width: "50px",
					height: "50px",
					borderRadius: "50px",
				}}
			>
				<Image src={linkIcon} alt="Information" width="25px" />
			</Container>
			<Container px={0} mx={0} style={{ width: "230px" }}>
				<Group direction="column" spacing={10}>
					<TextInput
						label="Link:"
						size="xs"
						styles={{
							root: {
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								width: "100%",
								color: "#A4BAC6",
							},
							label: {
								paddingLeft: "5px",
								paddingRight: "10px",
								fontSize: "14px",
								color: "#A4BAC6",
							},
							input: { backgroundColor: "#040F1F" },
						}}
						value={link}
						onChange={(event) => {
							setLink(event.currentTarget.value);
							changeLinkspotlink(
								activePanoId,
								selectedObject.id,
								event.currentTarget.value
							);
						}}
					/>
					<Group
						direction="row"
						style={{
							justifyContent: "end",
							alignItems: "center",
							width: "100%",
						}}
					>
						<Button
							variant="outline"
							size="xs"
							radius={"sm"}
							py={5}
							style={{
								fontWeight: "normal",
								fontSize: "14px",
								color: "#ffffff",
								backgroundColor: "#e03131",
								borderColor: "#e03131",
							}}
							onClick={() => {
								deleteLinkspot(activePanoId, selectedObject.id);
								closeControls();
							}}
						>
							Delete
						</Button>
					</Group>
				</Group>
			</Container>
		</Group>
	);
}

export default EmbedLinkControls;
